/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */

export { DocumentContext } from "./documentContext";
export { DocumentLambdaFactory } from "./lambdaFactory";
